import LanguageContext from "components/LanguageContext";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const skipLinkArray = ["main", "navigation", "search", "footer"];

const Skiplinks = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div className="fr-skiplinks">
      <nav role="navigation" aria-label="Accès rapide" className="fr-container">
        <ul className="fr-skiplinks__list">
          {skipLinkArray.map((link) => (
            <li key={`skipLink-${link}`}>
              <a className="fr-link" href={`#${link}`}>
                {t[language].skipLink[link]}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

Skiplinks.propTypes = {};

export default Skiplinks;
